exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#mobileViewOverlay .ProductCategory_productCategory__1VvXM{display:list-item;color:#333;cursor:pointer}#mobileViewOverlay .ProductCategory_productCategory__1VvXM .ProductCategory_productCategory__link__57nHk{display:block;padding:5px 15px;font-size:14px;text-decoration:none;color:inherit}#GlobalSearchApp .ProductCategory_productCategory__1VvXM{display:list-item;color:#333;cursor:pointer}#GlobalSearchApp .ProductCategory_productCategory__1VvXM .ProductCategory_productCategory__link__57nHk{display:block;padding:5px 15px;font-size:14px;text-decoration:none;color:inherit}@media only screen and (min-width:961px){#GlobalSearchApp .ProductCategory_productCategory__1VvXM{display:list-item;color:#333;cursor:pointer}#GlobalSearchApp .ProductCategory_productCategory__1VvXM:hover{background-color:#f5f5f5;color:#42b4e6}#GlobalSearchApp .ProductCategory_productCategory__1VvXM .ProductCategory_productCategory__link__57nHk{display:block;padding:5px 25px;text-decoration:none;color:inherit}}", ""]);

// exports
exports.locals = {
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333333",
	"textGray": "#9b9b9b",
	"textWhite": "#ffffff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"containerWidthMain": "960",
	"heightDesktopHeader": "136px",
	"productCategory": "ProductCategory_productCategory__1VvXM",
	"productCategory__link": "ProductCategory_productCategory__link__57nHk"
};